import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { Logger } from "../../../../infrastructure/logger";
import { UI } from "../../../../services/ui.service";
import { UploadService } from "../../../../infrastructure/upload/upload-service";
import {
  DynamicPromo,
  DynamicPromoInfo,
} from "../../../../domain/dyanmicPromo";
import { MediaRepository } from "../../../../domain/media-repository";
import { GraphicsRepository } from "../../../../domain/graphics-repository";

@Component({
  selector: "dynamic-promo-library-item",
  templateUrl: "./dynamicPromoLibraryItem.html",
  styleUrls: ["./dynamicPromoLibraryItem.scss"],
})
export class DynamicPromoLibraryItemComponent {
  @Input()
  item: DynamicPromo;

  @Input()
  viewMode: string = "gallery";

  dynamicPromoInfo: DynamicPromoInfo;
  menuOpen = false;
  dragged = false;

  packshotImage: string = null;

  @Output()
  deleteDynamicPromoEmitter = new EventEmitter();

  constructor(
    private ref: ElementRef,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private logger: Logger,
    private ui: UI,
    private mediaRepository: MediaRepository,
    private graphicsRepository: GraphicsRepository,
  ) {}

  ngOnInit() {
    this.mediaRepository.getMediaInfo(this.item.mediaId).then((mediaInfo) => {
      this.graphicsRepository
        .getGraphics(this.item.graphicsId)
        .then((graphicsInfo) => {
          this.dynamicPromoInfo = new DynamicPromoInfo(
            this.item.id,
            this.item.name,
            graphicsInfo,
            mediaInfo,
            this.item.thumbnail,
            this.item.startGraphicOffsetSeconds,
            this.item.trailerId,
          );
        });
      if (mediaInfo.contentSnapshotUrl) {
        this.packshotImage = mediaInfo.contentSnapshotUrl;
        this.changeDetectorRef.markForCheck();
      }
    });
    this.ref.nativeElement.addEventListener(
      "dragstart",
      this.onDragStart.bind(this),
      false,
    );
    this.ref.nativeElement.addEventListener(
      "dragend",
      this.onDragEnd.bind(this),
      false,
    );
  }

  deleteDynamicPromo() {
    this.ui.notify(this.ui.EVENTS.ShowConfirm, {
      title: "Delete dynamic promo",
      message: "Are you sure about that?",
      buttons: [
        {
          title: "Yes",
          callback: this.onDeleteConfirmed.bind(this),
        },
        {
          title: "No",
          callback: this.onDeleteCancelled.bind(this),
        },
      ],
    });
  }

  onDeleteConfirmed() {
    this.deleteDynamicPromoEmitter.emit();
  }

  onDeleteCancelled() {}

  editDynamicPromo() {
    this.router.navigate(["/scheduler/dynamicPromo/edit/", this.item.id]);
  }

  onDragStart(event: DragEvent) {
    this.dragged = true;
    event.dataTransfer.setData(
      "text/promo",
      JSON.stringify(this.dynamicPromoInfo),
    );
    event.dataTransfer.dropEffect = "copy";
  }

  onDragEnd(event) {
    this.dragged = false;
  }
}
